exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".duplicate-msg-badge {\n  margin-top: 2px;\n  margin-left: 3px;\n  font-size: 14px !important; }\n\n.duplicate-language-message-list-group .list-group-item {\n  padding: 2px 15px !important; }\n\n.duplicate-msg-tooltip {\n  top: 3px !important;\n  margin-left: 2px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tnt_control/component/message/duplicate_message/duplicate_message.scss
// module id = 1155
// module chunks = 1